/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
`

export default class SportTalkIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="15.422" height="13.644" viewBox="0 0 15.422 13.644" css={Color}
           className="sport-talk-ico">
        <path id="빼기_110" data-name="빼기 110"
              d="M7.213,12.644a.593.593,0,0,1-.4-.179l-.164-.148c-.281-.254-.571-.517-.851-.783a1.092,1.092,0,0,0-.786-.317h-.02c-.221,0-.62,0-1.068,0-.4,0-.767,0-.976,0A2.937,2.937,0,0,1,0,8.249C0,6.326,0,4.642,0,3.1A3.074,3.074,0,0,1,3.1,0L4.716,0h6.6a3.061,3.061,0,0,1,3.06,2.543,3.031,3.031,0,0,1,.044.561c0,2.076,0,3.664,0,5.149a2.993,2.993,0,0,1-.725,1.969,2.933,2.933,0,0,1-1.854.969,10.865,10.865,0,0,1-1.114.042c-.369,0-.73-.009-.943-.024-.057,0-.113-.006-.167-.006a1.566,1.566,0,0,0-1.243.552,6.173,6.173,0,0,1-.56.529c-.071.061-.14.122-.209.183A.593.593,0,0,1,7.213,12.644ZM10.888,4.8a.857.857,0,0,0-.836.836v.014a.841.841,0,0,0,.844.836.85.85,0,0,0,.6-.254.827.827,0,0,0,.239-.6A.841.841,0,0,0,10.888,4.8Zm-3.68,0a.857.857,0,0,0-.836.836v.014a.841.841,0,0,0,.844.836.85.85,0,0,0,.6-.254.827.827,0,0,0,.239-.6A.841.841,0,0,0,7.208,4.8Zm-3.68,0a.846.846,0,0,0-.836.836v.014a.841.841,0,0,0,.844.836.85.85,0,0,0,.6-.254.827.827,0,0,0,.239-.6A.841.841,0,0,0,3.528,4.8Z"
              transform="translate(0.498 0.5)" fill="#ecf2ff" stroke="rgba(0,0,0,0)" strokeMiterlimit="10"
              strokeWidth="1"/>
      </svg>
    )
  }
}